import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createChannel, createFolder, createRepo } from "./api.js";
import { queryClient } from "utils/react-query.js";

function buildRepoPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { name, id, project } = values;

  const repository_url = `https://github.com/7span/${project}-${name}`;

  return {
    projects: id,
    collection: "integrations_github",
    item: {
      repository_url: repository_url,
      suffix: name,
    },
  };
}

export const useRepoMutation = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildRepoPayload(values);
      const response = await createRepo(payload);
      return response;
    },
    onSuccess: () => {
      toast.success("Github repository created successfully");
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error.message);
    },
  });
};

function buildChannelPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { id } = values;

  return {
    projects: id,
    collection: "integrations_discord",
    item: {
      platform: "discord",
    },
  };
}

export const useChannelMutation = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildChannelPayload(values);
      const response = await createChannel(payload);
      return response;
    },
    onSuccess: () => {
      toast.success("Discord channel created successfully");
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error.message);
    },
  });
};

function buildFolderPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { id } = values;

  return {
    projects: id,
    collection: "integrations_drive",
    item: {
      platform: "google",
    },
  };
}

export const useFolderMutation = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildFolderPayload(values);
      const response = await createFolder(payload);
      return response;
    },
    onSuccess: () => {
      toast.success("Google Drive folder created successfully");
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error.message);
    },
  });
};
